module.exports = __webpack_public_path__ + "static/media/SharpSansNo2-Book.044892b4.otf";